import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DocumentsService} from "../../../../../services/document.service";
import {UtilsService} from "../../../../../services/utils.service";
import { environment } from 'src/environments/environment';
import {NgForOf, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import Swal from "sweetalert2";
declare var $: any;

@Component({
  selector: 'app-apuntes-cliente',
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    NgForOf
  ],
  templateUrl: './apuntes-cliente.component.html',
  styleUrl: './apuntes-cliente.component.css'
})
export class ApuntesClienteComponent implements OnInit, OnChanges{

  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice

  agregarNota: boolean = false;
  notaTxt: any;
  listaApuntes: any = []
  apunteSeleccionado: any = {}

  constructor(private documentService: DocumentsService,
              private utilsService: UtilsService) {
  }

  ngOnInit(): void {

  }
  ngOnChanges(changes: SimpleChanges): void {
      this.agregarNota = false;
      this.listaApuntes = []
      this.obtieneApuntesCliente()

  }

  agregarNotaFn(){
    this.agregarNota = true
    setTimeout(() => {
      $('textarea').focus()
    }, 500);


  }

  obtieneApuntesCliente(){
    this.listaApuntes = []
    this.documentService.getAttachmentByType(environment.businessId, this.detalleCliente.documentId, 'apuntesCliente').subscribe((res: any) => {
      let arrFecha: any = []

      arrFecha = res.content

      for(let i in arrFecha){
        let a = new Date(arrFecha[i].timestamp);
        let months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
        let year = a.getFullYear();
        let month = months[a.getMonth()];
        let date = a.getDate();
        let hour: any = a.getHours();
        let min:any = a.getMinutes();
        let sec = a.getSeconds();

        if (min < 10) min = '0' + min;
        if (hour < 10) hour = '0' + hour;

        let fechaMostrar = date + ' de ' + month + ' de ' + year + ', ' + hour + ':' + min ;

        arrFecha[i].fechaMostrar = fechaMostrar
      }

      arrFecha = arrFecha.sort((a, b) => a.timestamp - b.timestamp);

      this.listaApuntes = arrFecha

    }, err => {
      console.error(err)
    })
  }

  agregarApuntesFn(apuntes){
    let objeto: any = {}
    let attchId = this.utilsService.create_UUID()

    objeto = {
      "attachmentId": attchId,
      "documentId": this.detalleCliente.documentId,
      "timestamp": Date.now(),
      "apuntes": apuntes,
    }

    this.documentService.createDocumentAttachment(
        environment.businessId,
        this.detalleCliente.documentId,
        attchId,
        'apuntesCliente',
        null,
        objeto
    ).subscribe({
      next: (response: any) => {
        this.notaTxt = "";
        this.agregarNota = false;
        this.obtieneApuntesCliente()
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log('complete')
      }
    })

  }

  modalEditar(apuntes, indice){
    let y = Object.assign({}, apuntes);
    this.apunteSeleccionado = y
    this.apunteSeleccionado.indice = indice
    $('#modal-editar-apunte').modal('show')
  }

  guardaEdicionApuntes(apuntes){
    let objeto: any = {}
    let attchId = this.apunteSeleccionado.attachmentId

    objeto = {
      "attachmentId": attchId,
      "documentId": this.detalleCliente.documentId,
      "timestamp":this.apunteSeleccionado.timestamp,
      "apuntes": apuntes,
    }

    this.documentService.updateDocumentAttachment(
        environment.businessId,
        this.detalleCliente.documentId,
        attchId,
        'apuntesCliente',
        null,
        objeto
    ).subscribe({
      next: (response: any) => {
        this.listaApuntes[this.apunteSeleccionado.indice].apuntes = apuntes
        this.apunteSeleccionado = {}
        this.apunteSeleccionado = ''
        $('#modal-editar-apunte').modal('hide')
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        console.log('complete')
      }
    })

  }


}
